import AgeCalculatorDialog from './AgeCalculatorDialog';

export default AgeCalculatorDialog;
